// based on https://github.com/ngokevin/react-file-reader-input
import * as React from 'react';
import ReactDOM from 'react-dom';

export default class FileReaderInput extends React.Component {
    _reactFileReaderInput = null;

    constructor(props) {
        // FileReader compatibility warning.
        super(props);

        const win = typeof window === 'object' ? window : {};
        if (!win.File || !win.FileReader || !win.FileList || !win.Blob) {
            console.warn(
                '[react-file-reader-input] Some file APIs detected as not supported.' +
                ' File reader functionality may not fully work.'
            );
        }
    }

    handleChange = (e) => {
        const files = Array.prototype.slice.call(e.target.files); // Convert into Array
        const readAs = (this.props.as || 'default').toLowerCase();

        // Build Promise List, each promise resolved by FileReader.onload.
        Promise.all(files.map(file => new Promise((resolve, reject) => {

            // Read the file with format based on this.props.as.
            switch (readAs) {
                case 'binary': {
                    let reader = new FileReader();

                    reader.onload = result => {
                        // Resolve both the FileReader result and its original file.
                        resolve([result, file]);
                    };
                    reader.readAsBinaryString(file);
                    break;
                }
                case 'buffer': {
                    let reader = new FileReader();

                    reader.onload = result => {
                        // Resolve both the FileReader result and its original file.
                        resolve([result, file]);
                    };
                    reader.readAsArrayBuffer(file);
                    break;
                }
                case 'text': {
                    let reader = new FileReader();

                    reader.onload = result => {
                        // Resolve both the FileReader result and its original file.
                        resolve([result, file]);
                    };
                    reader.readAsText(file);
                    break;
                }
                case 'url': {
                    let reader = new FileReader();

                    reader.onload = result => {
                        // Resolve both the FileReader result and its original file.
                        resolve([result, file]);
                    };
                    reader.readAsDataURL(file);
                    break;
                }
                default: {
                    resolve([{target:{result:file}}, file]);
                    break;
                }
            }
        })))
            .then(zippedResults => {
                // Run the callback after all files have been read.
                if (this.props.onChange) {
                    this.props.onChange(e, zippedResults);
                }
            });
    }

    triggerInput = () => {
        const input = ReactDOM.findDOMNode(this._reactFileReaderInput);
        if (input) {
            input.click();
        }
    }

    render() {
        const { as, children, style, ...props } = this.props;

        const hiddenInputStyle = children ? {
            // If user passes in children, display children and hide input.
            position: 'absolute',
            left: '-9999px'
        } : {};

        return (
            <span className="react-file-reader-input" onClick={this.triggerInput} style={style}>
                <input
                    {...props}
                    type="file"
                    ref={(c) => { this._reactFileReaderInput = c; }}
                    onChange={this.handleChange}
                    onClick={() => { this._reactFileReaderInput.value = null; }}
                    style={hiddenInputStyle}
                />
                {children}
            </span>
        );
    }
}